<i18n lang="yaml">
ru:
  page_title: 'Регистрация'
  register_success: 'Подтверждение email'
  register_help_text_1: 'Проверьте email, указанный при регистрации '
  register_help_text_2: '. Мы отправили вам письмо с ссылкой для подтверждения регистрации. Если письмо не пришло, проверьте папку «Спам».'
  already_registered: 'Вы уже зарегистрированы на сайте.'
en:
  page_title: 'Registration'
  register_success: 'Email confirmation'
  register_help_text_1: 'Check email specified on registration '
  register_help_text_2: '. We send you a link to confirm registration. Check Spam folder you did not receive it.'
  already_registered: 'You have been registered.'
</i18n>

<template>
  <div v-if="$auth.loggedIn" class="container">
    <h1 class="text_align-center">
      {{ $t('already_registered') }}
      <nuxt-link :to="localePath('/')">{{ $t('to_homepage') }}</nuxt-link>
    </h1>
  </div>
  <div v-else-if="!$noCartMode()" class="container register">
    <site-text-block type="register_retailer" class="register-text-block" />

    <retailer-form @registration-completed="registrationCompleted = true" @set-email="(value) => email = value"/>
    
    <modal :visible="registrationCompleted && !!email" @close="redirectToMainPage">
      <template v-slot:header>
        <h3>{{ $t('register_success') }}</h3>
      </template>
      <template v-slot:body>
        {{ $t('register_help_text_1') }}<a href="#" @click.prevent>{{ email }}</a>{{ $t('register_help_text_2') }}
      </template>
      <template v-slot:footer>
        <button class="modal-default-button" @click="redirectToMainPage">{{ $t('continue') }}</button>
      </template>
    </modal>
  </div>
</template>


<script>
import RetailerForm from '@/components/forms/retailer-form';
import Modal from '@/components/modal';
import SiteTextBlock from '@/components/blocks/site-text-block';

export default {
  components: {
    RetailerForm,
    Modal,
    SiteTextBlock,
  },
  data() {
    return {
      registrationCompleted: false,
      email: null,
    }
  },
  mounted(){
    if(this.$noCartMode()){
      this.$nuxt.context.error({statusCode: 404});
      return
    }
  },
  head() {
    return {
      title: this.$t('page_title'),
    }
  },
  methods: {
    redirectToMainPage() {
      this.$router.push({path: this.localePath('/')});
    },
  },
}
</script>
